import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'antd'
import { PerTabBarContent } from '../../components/custom_components/TabBarContent'
import { KudosHRDashboard } from './KudosHRDasboard'
import { useAreKudosVisibleForMe } from '../../graphql/kudos/useKudosQueries'
import BackgroundBox from '../../components/custom_components/BackgroundBox'
import { NewLoadingAndErrors } from '../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'
import { KudosVisibilityPage } from './KudosVisibilityPage'
import { EmployeeSearch, KudosFilterInput } from '../../types'
import { KUDOS_DASHBOARD_PAGE_SIZE } from '../../graphql/kudos/util'

const { TabPane } = Tabs

enum KudosHRManagementPageContentTabs {
  kudosDashboard = 'kudosDashboard',
  kudosSettingsVisibility = 'kudosSettingsVisibility',
}

export const KudosHRManagementPage: FC = () => {
  const { data, loading, error } = useAreKudosVisibleForMe()
  const { t } = useTranslation()

  if (error || loading || !data) {
    return (
      <BackgroundBox r height="fullPage">
        <NewLoadingAndErrors isLoading={loading} error={error} hasNoData={!data} showSpinner t={t} />
      </BackgroundBox>
    )
  }

  return (
    <>
      <KudosHRManagementPageContent dashboardTabVisible={data.areKudosVisibleForMe} />
    </>
  )
}

export const KudosHRManagementPageContent: FC<{ dashboardTabVisible: boolean }> = ({ dashboardTabVisible }) => {
  const [activeTab, setActiveTab] = useState(
    dashboardTabVisible ? KudosHRManagementPageContentTabs.kudosDashboard : KudosHRManagementPageContentTabs.kudosSettingsVisibility,
  )
  const [filters, setFilters] = useState<KudosFilterInput>({
    pagination: {
      offset: 0,
      limit: KUDOS_DASHBOARD_PAGE_SIZE,
    },
  })
  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeSearch | null>(null)
  const [selectedAuthor, setSelectedAuthor] = useState<EmployeeSearch | null>(null)
  const { t } = useTranslation()

  const resetFiltersAfterVisibilityChange = () => {
    setFilters({
      ...filters,
      employeeId: undefined,
      authorId: undefined,
    })
    setSelectedEmployee(null)
    setSelectedAuthor(null)
  }

  return (
    <>
      <PerTabBarContent
        justify="center"
        tabs={
          <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key as KudosHRManagementPageContentTabs)}>
            {dashboardTabVisible && (
              <TabPane tab={t('kudos.management.tabs.header.dashboard')} key={KudosHRManagementPageContentTabs.kudosDashboard} />
            )}
            <TabPane
              tab={t('kudos.management.tabs.header.settingsVisibility')}
              key={KudosHRManagementPageContentTabs.kudosSettingsVisibility}
            />
          </Tabs>
        }
      />

      <Tabs activeKey={activeTab} renderTabBar={() => <></>}>
        {dashboardTabVisible && (
          <TabPane key={KudosHRManagementPageContentTabs.kudosDashboard}>
            <KudosHRDashboard
              filters={filters}
              setFilters={setFilters}
              selectedEmployee={selectedEmployee}
              selectedAuthor={selectedAuthor}
              setSelectedEmployee={setSelectedEmployee}
              setSelectedAuthor={setSelectedAuthor}
            />
          </TabPane>
        )}
        <TabPane key={KudosHRManagementPageContentTabs.kudosSettingsVisibility}>
          <KudosVisibilityPage resetFiltersAfterVisibilityChange={resetFiltersAfterVisibilityChange} />
        </TabPane>
      </Tabs>
    </>
  )
}
